import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />,
  'ExpandLess',
);
